import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, reactive, ref } from 'vue'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { salesClueDetail } from '@/api/overseasSales/clueManage'
import { useRoute } from 'vue-router'

const __default__ = { name: 'DcCosOFbuNewClientEvaluationAdd' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    demandInfo: { warehouses: [{}] },
    saleInfo: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  visitAddress: [{}]
})

const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))

onBeforeMount(() => {
  salesClueDetail({ clueId: route.query.clueId as string }).then((res) => {
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    if (res.data.clueId) {
      res.data.cosId = res.data.clueId
      res.data.clueId = undefined
    }
    if (res.data.follower) {
      res.data.seller = res.data.follower
    }
    if (res.data.contact) {
      res.data.contact = undefined
    }
    if (res.data.visitAddress) {
      res.data.visitAddress = undefined
    }
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(DetailForm, {
            ref: "detailFormRef",
            type: "add",
            isEdit: "",
            value: dataForm,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
            resetValue: initForm
          }, null, 8, ["value", "resetValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})